import { render } from "./CampaignLayout.vue?vue&type=template&id=8fb6e408&scoped=true"
import script from "./CampaignLayout.vue?vue&type=script&lang=js"
export * from "./CampaignLayout.vue?vue&type=script&lang=js"

import "./CampaignLayout.vue?vue&type=style&index=0&id=8fb6e408&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb6e408"]])

export default __exports__